import { createFileRoute, Outlet } from '@tanstack/react-router';

// Wrapper screen for Outlet to preserve .ORG url for these screens
function QuizSubmissionsScreen() {
  return <Outlet />;
}

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/quiz-submissions',
)({
  component: QuizSubmissionsScreen,
});
